// // assets
// import { FileProtectOutlined,CarOutlined,FieldTimeOutlined, EditFilled} from '@ant-design/icons';

// // icons<FieldTimeOutlined />
// const icons = {
//   FileProtectOutlined,
//   CarOutlined,
//   FieldTimeOutlined,
//   EditFilled
// };

// // ==============================|| MENU ITEMS - REPORTS ||============================== //

// const reports= {
//   id: 'group-reports',
//   title: 'Reports',
//   type: 'group',
//   children: [
//     {
//       id: 'attendanceReports',
//       title: 'Attendance Report',
//       type: 'item',
//       url: '/attendance-report',
//       icon: icons.FileProtectOutlined,
//       breadcrumbs: false
//     },
//     {
//       id: 'travelReport',
//       title: 'Travel Report',
//       type: 'item',
//       url: '/travel-report',
//       icon: icons.CarOutlined,
//       breadcrumbs: false
//     },
//     {
//       id: 'expenseReport',
//       title: 'Expense Report',
//       type: 'item',
//       url: '/expense-report',
//       icon: icons.FieldTimeOutlined,
//       breadcrumbs: false
//     },
//     {
//       id: 'updateTravelReport',
//       title: 'Travel Update',
//       type: 'item',
//       url: '/travel-update',
//       icon: icons.EditFilled,
//       breadcrumbs: false
//     }
//   ]
// };

// export default reports;




// // assets
// import { FileProtectOutlined,ProfileOutlined, CarOutlined, FieldTimeOutlined, EditFilled } from '@ant-design/icons';

// const icons = {
//   FileProtectOutlined,
//   CarOutlined,
//   FieldTimeOutlined,
//   EditFilled,
//   ProfileOutlined
// };

// const reports = (roleID) => {
//   return roleID == 1
//     ? {
//         id: 'group-reports',
//         title: 'Reports',
//         type: 'group',
//         children: [
//           { id: 'attendanceReports', title: 'Attendance Report', type: 'item', url: '/attendance-report', icon: icons.FileProtectOutlined, breadcrumbs: false },
//           { id: 'dailyAttendance', title: 'Daily Attendance', type: 'item', url: '/daily-attendance', icon: icons.ProfileOutlined, breadcrumbs: false },
//           { id: 'travelReport', title: 'Travel Report', type: 'item', url: '/travel-report', icon: icons.CarOutlined, breadcrumbs: false },
//           { id: 'expenseReport', title: 'Expense Report', type: 'item', url: '/expense-report', icon: icons.FieldTimeOutlined, breadcrumbs: false },
//           { id: 'updateTravelReport', title: 'Travel Update', type: 'item', url: '/travel-update', icon: icons.EditFilled, breadcrumbs: false },
//         ]
//       }
//     : {
//         id: 'group-reports',
//         title: '',
//         type: 'group',
//         children: []
//       };
// };

// export default reports;





// // assets
// import { FileProtectOutlined,CarOutlined,FieldTimeOutlined, EditFilled, ProfileOutlined, StockOutlined} from '@ant-design/icons';

// // icons<FieldTimeOutlined />
// const icons = {
//   FileProtectOutlined,
//   CarOutlined,
//   FieldTimeOutlined,
//   EditFilled,
//   ProfileOutlined,
//   StockOutlined
// };

// // ==============================|| MENU ITEMS - REPORTS ||============================== //

// const reports= {
//   id: 'group-reports',
//   title: 'Reports',
//   type: 'collapse',
//   icon: icons.StockOutlined,
//   children: [
//     {
//       id: 'travelReport',
//       title: 'Travel Report',
//       type: 'item',
//       url: '/travel-report',
//       icon: icons.CarOutlined,
//       breadcrumbs: false
//     },
//     {
//       id: 'expenseReport',
//       title: 'Expense Report',
//       type: 'item',
//       url: '/expense-report',
//       icon: icons.FieldTimeOutlined,
//       breadcrumbs: false
//     },
//     {
//       id: 'updateTravelReport',
//       title: 'Travel Update',
//       type: 'item',
//       url: '/travel-update',
//       icon: icons.EditFilled,
//       breadcrumbs: false
//     },
//     { 
//       id: 'dailyAttendance', 
//       title: 'Daily Attendance', 
//       type: 'item', 
//       url: '/daily-attendance', 
//       icon: icons.ProfileOutlined, 
//       breadcrumbs: false 
//     },
//     { 
//       id: 'stockVerification', 
//       title: 'Stock Verification', 
//       type: 'item', 
//       url: '/stock-verification', 
//       icon: icons.StockOutlined, 
//       breadcrumbs: false 
//     },

//   ]
// };

// export default reports;




import { CarOutlined, FieldTimeOutlined, EditFilled, ProfileOutlined, StockOutlined,ClusterOutlined,ReconciliationOutlined,EnvironmentOutlined,TransactionOutlined } from '@ant-design/icons';

const icons = { CarOutlined, FieldTimeOutlined, EditFilled, ProfileOutlined, StockOutlined,ClusterOutlined,ReconciliationOutlined,EnvironmentOutlined,TransactionOutlined };
const roles = [0,1,2];

const reports = {
  id: 'group-reports',
  title: 'Reports',
  type: 'collapse',
  icon: icons.StockOutlined,
  roles,
  children: [
    { id: 'travelReport', title: 'Travel Report', type: 'item', url: '/travel-report', icon: icons.CarOutlined, breadcrumbs: false, roles },
    { id: 'expenseReport', title: 'Expense Report', type: 'item', url: '/expense-report', icon: icons.FieldTimeOutlined, breadcrumbs: false, roles },
    { id: 'approvedExpenseReport', title: 'Approved Expense Report', type: 'item', url: '/approved-expense-report', icon: icons.TransactionOutlined, breadcrumbs: false, roles },
    { id: 'updateTravelReport', title: 'Travel Update', type: 'item', url: '/travel-update', icon: icons.EditFilled, breadcrumbs: false, roles },
    { id: 'dailyAttendance', title: 'Daily Attendance', type: 'item', url: '/daily-attendance', icon: icons.ProfileOutlined, breadcrumbs: false, roles },
    { id: 'activityreports', title: 'Activity Reports', type: 'item', url: '/activity-report', icon: icons.ReconciliationOutlined, breadcrumbs: false, roles },
    { 
      id: 'LiveActivityMap', 
      title: 'Live Activity Map', 
      type: 'item', 
      url: '/live-activity-map', 
      icon: icons.EnvironmentOutlined, 
      breadcrumbs: false 
    },
     { id: 'stockVerification', title: 'Stock Verification', type: 'item', url: '/stock-verification', icon: icons.StockOutlined, breadcrumbs: false, roles }
  ]
};

export default reports;
